import React from 'react';

function highlightText(
  line: string,
  highlights: readonly string[],
  highlightClassName: string,
): React.ReactNode {
  if (!highlights.length) return line;

  const sorted = [...highlights].sort((a, b) => b.length - a.length);
  const pattern = sorted
    .map((str) => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'))
    .join('|');
  const regex = new RegExp(`(${pattern})`, 'g');

  return line.split(regex).map((part, idx) =>
    sorted.includes(part) ? (
      <span key={`h-${idx}`} className={highlightClassName}>
        {part}
      </span>
    ) : (
      <React.Fragment key={`t-${idx}`}>{part}</React.Fragment>
    ),
  );
}

/** 줄바꿈·부분 강조(학과 시험 안내 등) */
export function highlightTextWithLineBreaks(
  content: string,
  highlights: readonly string[],
  highlightClassName: string,
): React.ReactNode {
  if (!content) return null;

  const lines = content.split('\n');
  return lines.map((line, lineIdx) => (
    <React.Fragment key={lineIdx}>
      {highlightText(line, highlights, highlightClassName)}
      {lineIdx < lines.length - 1 ? <br /> : null}
    </React.Fragment>
  ));
}
